import React from "react";

import { ContentModule } from "utils/orm";
import { ArticleBody } from "components/ArticleBody";
import { AuthorModule, AuthorBlock } from "components/AuthorModule";
import { SponsorModule, SponsorProps } from "components/SponsorModule";
import { getTOCEntries } from "components/TocModule";

import styles from "components/articleContainer.module.scss";

export interface ArticleContentProps {
    articleContentModules: ContentModule[];
    blockHeadingPrefix?: string;
    listBuilder?: ContentModule[];
    postListBodyContent?: ContentModule[];
    sponsorModuleProps: SponsorProps;
    templateName: string;
    author: AuthorBlock;
}

export const ArticleContent = (props: ArticleContentProps) => {
    const {
        articleContentModules,
        blockHeadingPrefix,
        listBuilder,
        postListBodyContent,
        sponsorModuleProps,
        templateName,
        author,
    } = props;

    // tocEntities is a collection of all the objects passed to the article in each of the 3 sections.
    // These are used only in the first section to discover the needed elements from the full page to build a TOC.
    const tocEntities = getTOCEntries([].concat(articleContentModules, listBuilder, postListBodyContent));

    const bodyProps = {
        articleContentModules,
        blockHeadingPrefix,
        listBuilder,
        postListBodyContent,
        templateName,
        tocEntities
    };

    return (
        <div className={styles.articleContent}>
            <div className={styles.contentModule}>
                <ArticleBody {...bodyProps} />
                <SponsorModule {...{ sponsorType: "footer", ...sponsorModuleProps }} />
                <AuthorModule {...author} />
            </div>
        </div>
    );
};
